export default __webpack_public_path__ + "static/media/memberFileIcon_up.89f6fa1f.svg";